import React from "react";

import AlertsAndSoundsPreferencesCommon from "@/features/settings/AlertsAndSoundsPreferencesCommon.jsx";

export default function PatientAlertsAndSounds() {
  return <AlertsAndSoundsPreferencesCommon role="patient" />;
}
